import { Component, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EnumEscala } from '../../enums/escala.enum';
import { EscalasRentabilidadeStore, IEscalaRentabilidade } from '../../services/escalas-rentabilidade.store';

@Component({
  selector: 'sgt-escala-rentabilidade',
  templateUrl: './escala-rentabilidade.component.html',
  styleUrls: ['./escala-rentabilidade.component.scss']
})
export class EscalaRentabilidadeComponent implements OnDestroy {
  private _id: EnumEscala;

  @Input()
  set id(value: EnumEscala) {
    this._id = value ?? EnumEscala.CRITICO;
    this.loadEscala();
  }
  get id(): EnumEscala {
    return this._id;
  }

  @Input() showText = false;
  @Input() showSymbol = true;

  EnumEscala = EnumEscala;
  escala: IEscalaRentabilidade | null = null;

  private destroy$ = new Subject<void>();

  constructor(private escalasStore: EscalasRentabilidadeStore) {}

  private loadEscala(): void {
    this.escalasStore.getEscalaById$(this._id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(escala => {
        this.escala = escala ?? null;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
